import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import LZString from "lz-string";
import Loader from "@/components/loader/Loader.vue";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
let VeevaAISpeachLoader = class VeevaAISpeachLoader extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "documentId", void 0);
    _defineProperty(this, "jobID", null);
    _defineProperty(this, "pollInterval", null);
    _defineProperty(this, "pollCount", 0);
    _defineProperty(this, "maxPolls", 300);
    // 5 minutes max
    _defineProperty(this, "statusMessage", '');
    _defineProperty(this, "hasError", false);
    _defineProperty(this, "errorMessage", '');
  }
  mounted() {
    this.statusMessage = this.$t('veeva.loading.starting');
    this.startDownload();
  }
  beforeUnmount() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  }
  async startDownload() {
    this.hasError = false;
    this.errorMessage = '';
    this.pollCount = 0;
    this.statusMessage = this.$t('veeva.loading.starting');
    try {
      const response = await axios.post(`/recorder/veeva/startDownload/${this.documentId}`);
      this.jobID = response.data;
      this.statusMessage = this.$t('veeva.loading.downloading');
      this.pollInterval = window.setInterval(() => this.pollStatus(), 1000);
    } catch (error) {
      this.showError(this.$t('veeva.loading.error.start') + ': ' + (error.message || error));
    }
  }
  async pollStatus() {
    this.pollCount++;
    if (this.pollCount > this.maxPolls) {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
      }
      this.showError(this.$t('veeva.loading.error.timeout'));
      return;
    }
    try {
      const response = await axios.get(`/recorder/veeva/jobStatus/${this.jobID}`);
      const data = response.data;
      if (data === '' || data === null) {
        // Still processing - update status with animation
        const dots = '.'.repeat(this.pollCount % 3 + 1);
        this.statusMessage = this.$t('veeva.loading.downloading') + dots;
        return;
      }
      // Processing complete
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
      }
      // Check if it's an error response
      if (typeof data === 'string' && data.startsWith('ERROR:')) {
        const errorJson = data.substring(6);
        try {
          const errorObj = JSON.parse(errorJson);
          this.showError(errorObj.error || this.$t('veeva.loading.error.unknown'));
        } catch (e) {
          this.showError(this.$t('veeva.loading.error.unknown'));
        }
        return;
      }
      // Check if data is an error object
      if (data.error) {
        this.showError(data.error);
        return;
      }
      // Success - redirect to AI Speach Generator
      this.statusMessage = this.$t('veeva.loading.success');
      // Compress and redirect with the file IDs
      const compressed = LZString.compressToEncodedURIComponent(JSON.stringify(data));
      window.location.href = `/recorder/aiSpeachGenerator?initFilesJson=${compressed}&linkID=${this.documentId}`;
    } catch (error) {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
      }
      this.showError(this.$t('veeva.loading.error.status') + ': ' + (error.message || error));
    }
  }
  showError(message) {
    this.hasError = true;
    this.errorMessage = message;
  }
};
__decorate([Prop({
  required: true
})], VeevaAISpeachLoader.prototype, "documentId", void 0);
VeevaAISpeachLoader = __decorate([Component({
  components: {
    Loader,
    Icon,
    StandardButton
  }
})], VeevaAISpeachLoader);
export default VeevaAISpeachLoader;